import { Pipe, PipeTransform } from '@angular/core';

/**
 * Wraps occurrences of `term` in `<mark class="search-highlight">` tags.
 * Only safe for plain-text input — do NOT use with HTML content.
 */
@Pipe({
  name: 'highlight',
  standalone: true,
})
export class HighlightPipe implements PipeTransform {
  transform(text: string | null | undefined, term: string | null | undefined): string {
    if (!text || !term?.trim()) return text ?? '';

    const escaped = term.trim().replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    const regex = new RegExp(`(${escaped})`, 'gi');
    return text.replace(regex, '<mark class="search-highlight">$1</mark>');
  }
}
